export const GARDEN_TYPE_ID_INDIVIDUAL = 1;
export const GARDEN_TYPE_ID_GROUP = 2;
export const GARDEN_TYPE_ID_PUBLIC = 3;
export const GARDEN_OPENING_TYPE_ID_STANDARD = 1;
export const GARDEN_OPENING_TYPE_ID_EVENING = 2;
export const GARDEN_OPENING_TYPE_ID_BY_ARRANGEMENT_ONLY = 3;
export const GARDEN_OPENING_TYPE_ID_ALSO_BY_ARRANGEMENT = 4;
export const GARDEN_OPENING_TYPE_ID_OPENING_WITHIN_GROUP = 5;
export const GARDEN_OPENING_TYPE_ID_GOP_NO_NGS_DATES = 6;
const FILTER_DAYS_OPEN_LABEL = 'days_open';
const FILTER_DAYS_OPEN_OPTIONS = 'next-7-days';
const FILTER_OPENING_TYPE_LABEL = 'opening_type';
const FILTER_OPENING_TYPE_OPTIONS = 'opening';

export const FILTER_DAYS_OPEN_ALL_DATES = 'all-dates';
export const FILTER_OPEN_STATUS_LABEL = 'open_status';
export const FILTER_OPEN_STATUS_NO_UPCOMING_OPENINGS = 'no-upcoming-openings';

// Filter options fetched from GET /gardens/filters are cached in localStorage
// (via vuex-persistedstate). The cache is treated as invalid, and refetched,
// when either:
//   - more than FILTER_CACHE_TTL_MS has elapsed since it was last fetched, or
//   - FILTER_CACHE_VERSION no longer matches the stamp stored with the cache.
// Bump FILTER_CACHE_VERSION whenever the shape of the filter payload, or the
// way the app consumes it, changes in a way that makes old caches unusable.
export const FILTER_CACHE_VERSION = 1;
export const FILTER_CACHE_TTL_MS = 24 * 60 * 60 * 1000; // 1 day

// Tracks which input the visitor most recently engaged in the home search
// form. Drives the typing-time state machine that picks a name-search vs
// location-search baseline.
export const SEARCH_CONTEXT_NAME = 'name';
export const SEARCH_CONTEXT_LOCATION = 'location';

export const GARDEN_OPENING_TYPE_IDS_OPENING = [
  GARDEN_OPENING_TYPE_ID_STANDARD,
  GARDEN_OPENING_TYPE_ID_EVENING,
  GARDEN_OPENING_TYPE_ID_OPENING_WITHIN_GROUP,
  GARDEN_OPENING_TYPE_ID_GOP_NO_NGS_DATES,
];

export const GARDEN_OPENING_TYPE_IDS_ARRANGEMENT = [
  GARDEN_OPENING_TYPE_ID_BY_ARRANGEMENT_ONLY,
  GARDEN_OPENING_TYPE_ID_ALSO_BY_ARRANGEMENT,
];
const filterDaysOpen = {};
Object.defineProperty(filterDaysOpen, 'filter', {
  value: FILTER_DAYS_OPEN_LABEL,
  writable: false,
  enumerable: true,
  configurable: true,
});
Object.defineProperty(filterDaysOpen, 'options', {
  value: FILTER_DAYS_OPEN_OPTIONS,
  writable: false,
  enumerable: true,
  configurable: true,
});
const filterOpeningType = {};
Object.defineProperty(filterOpeningType, 'filter', {
  value: FILTER_OPENING_TYPE_LABEL,
  writable: false,
  enumerable: true,
  configurable: true,
});
Object.defineProperty(filterOpeningType, 'options', {
  value: FILTER_OPENING_TYPE_OPTIONS,
  writable: false,
  enumerable: true,
  configurable: true,
});
export const DEFAULTFILTERS = [
  filterDaysOpen,
  filterOpeningType,
]

export const FILTER_SIDEBAR_TYPE_AND_STATUS_KEYS = [
  'garden_type',
  'open_status',
  'type_status_extras',
]

export const FILTER_SIDEBAR_TAG_KEYS = [
  'garden_style',
  'seasonal_features',
  'about_visit',
]

export const FILTER_SIDEBAR_SECTION_KEYS = [
  ...FILTER_SIDEBAR_TYPE_AND_STATUS_KEYS,
  ...FILTER_SIDEBAR_TAG_KEYS,
]
